module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search-icon"
    },
    on: {
      "click": function($event) {
        _vm.clicked('s')
      }
    }
  }), _vm._v(" "), _c('div', {
    class: {
      open: _vm.sideOpen
    },
    attrs: {
      "id": "menu-icon"
    },
    on: {
      "click": function($event) {
        _vm.clicked('m')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "side-menu",
    class: {
      visible: _vm.sideOpen
    }
  }, [(_vm.menu) ? _c('div', _vm._l((_vm.linkGroups), function(links) {
    return _c('div', {
      staticClass: "linkGroup"
    }, _vm._l((links), function(link) {
      return _c('div', [_c('a', {
        attrs: {
          "href": link.url
        }
      }, [_vm._v(_vm._s(link.display))])])
    }))
  })) : (_vm.search) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFilter),
      expression: "searchFilter"
    }],
    ref: "input",
    staticClass: "search",
    attrs: {
      "id": "search",
      "placeholder": "Type to Search"
    },
    domProps: {
      "value": (_vm.searchFilter)
    },
    on: {
      "focus": function($event) {
        _vm.poppedUp = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFilter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.searchResults), function(city) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '/cities/view/' + city.City.slug
      }
    }, [_c('div', {
      staticClass: "popup-city-li"
    }, [_c('div', {
      staticClass: "table img"
    }, [_c('div', {
      staticClass: "table-cell"
    }, [_c('img', {
      attrs: {
        "src": '/file-manager/userfiles/_thumbs/flags/' + city.City.flag_path.replace('.png', '.jpg')
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "popup-city-city",
      domProps: {
        "innerHTML": _vm._s(city.City.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "popup-city-region",
      domProps: {
        "innerHTML": _vm._s(city.Region.name)
      }
    })])])])
  }))]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site-title"
    }
  }, [_c('h1', {
    attrs: {
      "id": "site-title"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Atlas of Urban Expansion")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c60c39b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 304
// module chunks = 1